import { Button } from "@mui/material";
import style from "./Navbar.module.css";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

const Navbar = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <nav className={style.container}>
      {isAuthenticated ? (
        <>
          <div className={style.buttonWrapper}>
            <Button
              component={Link}
              to="/mashlist/list"
              variant="contained"
              className={`${style.btn} ${style.myListsBtn}`}
              startIcon={<FormatListBulletedIcon />}
            >
              My Lists
            </Button>
          </div>
          <div className={style.buttonWrapper}>
            <Button
              component={Link}
              to="/mashlist/wizard"
              variant="contained"
              className={`${style.btn} ${style.createBtn}`}
              startIcon={<AddCircleOutlineIcon />}
            >
              Make a Mash-List
            </Button>
          </div>
          <div className={style.buttonWrapper}>
            <Button
              onClick={handleLogout}
              variant="outlined"
              className={`${style.btn} ${style.logoutBtn}`}
              startIcon={<LogoutIcon />}
            >
              Logout
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className={style.buttonWrapper}>
            <Button
              component={Link}
              to="/login"
              variant="contained"
              className={`${style.btn} ${style.loginBtn}`}
            >
              Login
            </Button>
          </div>
          <div className={style.buttonWrapper}>
            <Button
              component={Link}
              to="/register"
              variant="contained"
              className={`${style.btn} ${style.signupBtn}`}
            >
              Sign Up
            </Button>
          </div>
        </>
      )}
    </nav>
  );
};

export default Navbar;
